import { transitionDurationInSec } from '../../constants';
export var transition = function transition(transitions) {
  return function (_ref) {
    var theme = _ref.theme;
    return "transition: ".concat(Object.keys(transitions).map(function (property) {
      var transitionOption = transitions[property];
      var duration = "".concat(transitionDurationInSec, "s");

      if (typeof transitionOption === 'number') {
        duration = "".concat(transitionOption, "s");
      }

      return "".concat(property, " ").concat(duration, " ease");
    }).join(','), ";");
  };
};